import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatChipsModule, MatIconModule, MatFormFieldModule } from '@angular/material';

import { ChipsComponent } from './chips.component';

@NgModule({
  imports: [ CommonModule, MatChipsModule, MatIconModule, MatFormFieldModule ],
  declarations: [ ChipsComponent ],
  exports: [ ChipsComponent ]
})
export class ChipsModule {
}

export function chipsModuleFactory() {
  return ChipsModule;
}
